import { serverCall } from 'utils/serverCall';
import {
  initCompanyListRequest,
  setCompanyList,
  addCompany,
  updateCompany,
  setCompany,
  errorComapny,
  errorCompanyList,
  deleteCompany,
} from './action'; 
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';

export const fetchCompanyList = ({ searchQuery = null,  currentPage = null, rowsPerPage = null }= {}) => {
  return async (dispatch) => {
    dispatch(initCompanyListRequest());
    const params = new URLSearchParams();
    if (searchQuery !== null) params.append('search', searchQuery);
    if (currentPage !== null) params.append('page', currentPage);
    if (rowsPerPage !== null) params.append('limit', rowsPerPage);
    try {
      const result = await serverCall(`${apiEndpoints.COMPANY_LIST}/?${params.toString()}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setCompanyList(result?.data?.payload));
      } else {
        dispatch(errorCompanyList(result.message));
      }
    } catch (error) {
      dispatch(errorCompanyList(error.message));
    }
  };
};

export const createCompany = (companyData, toggleModal) => {
  return async (dispatch) => {
    dispatch(initCompanyListRequest());
    try {
      const result = await serverCall(apiEndpoints.COMPANY_CREATE, 'POST', dispatch, companyData);
      if (result.success) {
        dispatch(addCompany(result?.data?.payload?.newCompany));
        dispatch(fetchCompanyList())
        toggleModal();
        toast.success('Company created successfully');
        return Promise.resolve();
      } else {
        toast.error(result.message);
        dispatch(errorComapny(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorComapny(error.message));
      return Promise.reject(error);
    }
  };
};

export const fetchCompanyById = (companyId, stateToManage) => {
  return async (dispatch) => {
    dispatch(initCompanyListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.COMPANY_BYID}/${companyId}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setCompany(result?.data?.payload));
        stateToManage((prevState) => !prevState)
        

      } else {
        dispatch(errorComapny(result.message));
      }
    } catch (error) {
      dispatch(errorComapny(error.message));
    }
  };
};

export const updateCompanyById = (companyId, companyData, toggleModal, searchQuery) => {
  return async (dispatch) => {
    dispatch(initCompanyListRequest());
    try {
      const result = await serverCall(`${apiEndpoints.COMPANY_UPDATE}/${companyId}`, 'POST',dispatch, companyData);
      if (result.success) {
        dispatch(fetchCompanyList({searchQuery}))
        dispatch(updateCompany(result?.data?.payload?.updatedCompany));
        toggleModal();
        toast.success('Company updated successfully');
      } else {
        toast.error(result.message);
        dispatch(errorComapny(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorComapny(error.message));
    }
  };
};

export const deleteCompanyById = (payload,toggleModal) => {
  return async (dispatch) => {
    dispatch(initCompanyListRequest());
    try {
      const {id:companyId, currentPage, rowsPerPage} = payload 
      const result = await serverCall(`${apiEndpoints.COMPANY_DELETE}/${companyId}`, 'DELETE', dispatch);
      if (result.success) {
        dispatch(deleteCompany(companyId)); 
        dispatch(fetchCompanyList({ searchQuery:'',  currentPage, rowsPerPage }));
        toast.success(result.message || 'Company deleted successfully');
        toggleModal()
      } else {
        toast.error(result.message);
        dispatch(errorComapny(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorComapny(error.message)); 
    }
  };
};
